import { MediaDrawer } from './MediaDrawer'
import { SelectMediaDrawerProps, SelectMediaProps, UploadedMediaCarouselProps } from '../Types'
import { useUploads } from 'components/Design/UploadsTab/useUploads'
import { collectResults } from 'utils/query'
import { getMediaFiles } from 'components/Design/UploadsTab/getMediaFiles'
import { MediaFileGrid } from './MediaFileGrid'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'

interface UploadsDrawerProps extends SelectMediaDrawerProps, UploadedMediaCarouselProps {}

export const UploadsDrawer = observer((props: UploadsDrawerProps) => {
  const { accept, onSelect, ...rest } = props
  const { closeDrawer } = useRootStore().drawersStore
  const uploadsQuery = useUploads()
  const uploads = collectResults(uploadsQuery, (data) => data.files)
  const mediaFiles = getMediaFiles(uploads, accept)

  const handleSelect = ({ file, needsDownload }: SelectMediaProps) => {
    onSelect({ file, needsDownload, provider: 'uploads' })
    closeDrawer()
  }

  return (
    <MediaDrawer {...rest}>
      <MediaFileGrid mediaFiles={mediaFiles} onSelect={handleSelect} isLoading={uploadsQuery.isLoading} />
    </MediaDrawer>
  )
})
